
import Button from './src/button.vue';

Button.install = function (Vue) {
  Vue.component(Button.name, Button);
};

export default Button;



//////////////////
// WEBPACK FOOTER
// ./package/button/index.js
// module id = null
// module chunks = 